import ukraineCities from "./cities.json";
import urkaineCitiesAndRegions from "./cities_regions.json";

export const cities = ukraineCities;
export const selectCities = urkaineCitiesAndRegions;
